import { render } from "./Tool.vue?vue&type=template&id=393d459b"
import script from "./Tool.vue?vue&type=script&lang=ts"
export * from "./Tool.vue?vue&type=script&lang=ts"

import "./Tool.vue?vue&type=style&index=0&id=393d459b&lang=scss"
script.render = render

export default script